import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { StepTemplate } from '../../components/styled/stepTemplate/StepTemplate'
import { Button } from '../../components/styled/Button/Button'
import { IntentGermanString, Intent } from '../../@types/intent'
import { updateIntent } from '../../store/lead/leadSlice'
import { getCustomDimensionForIntent } from '../../tracking/tracking'
import { Progress } from '../../@types/progress'
import { reportTrackingEvent } from '../../tracking/thunks'
import { useReportViewEvent } from '../../hooks'
import { RealEstateType } from '../../@types/realEstateType'
import { IntentStepIcon } from '../../components/icons/StepIcons/IntentStepIcon'
import { IntegrationType } from '../../@types/config'
import { ReduxState } from '../../store/reducers'

interface IntentStepProps {
  goToNextStep: () => unknown
  goToPreviousStep: () => unknown
  progress: Progress
  displayBack: boolean
}

export const headline = 'Für welches Thema interessierst du dich?'

export const IntentStep: FC<IntentStepProps> = (props) => {
  useReportViewEvent({ pageTitle: 'intent' })
  const {
    config: { theme, integrationType },
    lead: { realEstateType },
  } = useSelector((state: ReduxState) => state)
  const isIv24Integration = integrationType === IntegrationType.IMMOVERKAUF24

  const dispatch = useDispatch()

  const goToNextStep = (intent: Intent) => {
    const intent_value = intent === Intent.MAKLER_SALE ? 'sell' : `${getCustomDimensionForIntent(intent)}`
    dispatch(updateIntent(intent))
    dispatch(
      reportTrackingEvent({
        isTrackingIntent: realEstateType === RealEstateType.COMMERCIAL,
        pageTitle: 'intent',
        label: `intent_submit`,
        inputValue: `intent_${intent_value}`,
        eventName: 'lead_input',
        customDimensions: {
          ga_cd_lead_engine_input_value: `intent_${intent_value}`,
        },
      })
    )

    props.goToNextStep()
  }

  return (
    <StepTemplate
      icon={<IntentStepIcon />}
      headline={headline}
      displayNext={false}
      goToPreviousStep={props.goToPreviousStep}
      progress={props.progress}
      displayBack={props.displayBack}
      backgroundColor={theme.background}
      textColor={theme.text}
    >
      {Object.entries(IntentGermanString).map(([key, label]) => (
        <Button
          key={key}
          text={label}
          onClick={() => goToNextStep(Intent[key as Intent])}
          className='margin-right-m margin-bottom-xl'
          dataTesting={`option-${key}`}
          backgroundColor={isIv24Integration ? theme.secondary : theme.background}
          color={isIv24Integration ? '#FFFFFF' : theme.text}
          borderColor={theme.secondary}
        />
      ))}
    </StepTemplate>
  )
}

export default IntentStep
